var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19531 3.80859V7.05062H6.43733",
    stroke: "#8927EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55156 9.75244C4.90191 10.7469 5.56595 11.6005 6.44363 12.1847C7.32131 12.7689 8.36508 13.0521 9.41768 12.9915C10.4703 12.9309 11.4747 12.5299 12.2795 11.8488C13.0844 11.1678 13.6461 10.2436 13.8801 9.21554C14.114 8.18749 14.0075 7.11125 13.5766 6.14899C13.1457 5.18672 12.4137 4.39057 11.491 3.88047C10.5683 3.37038 9.50477 3.17398 8.46072 3.32087C7.41667 3.46776 6.44863 3.94999 5.70248 4.69489L3.19531 7.05076",
    stroke: "#8927EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.dec535bf86a021083857186e78db1a6e.svg";
export { ForwardRef as ReactComponent };